export const Endpoint = process.env.VUE_APP_ENDPOINT;
// export const Endpoint = "http://localhost:5000"